export function getSegmentOptions() {
  return getVoyageFormSegmentOptions().map((opt) => opt.value);
}

/** Port Performance new voyage form Segment dropdown (label shown, value stored). */
export function getVoyageFormSegmentOptions(): Array<{
  label: string;
  value: string;
}> {
  return [
    { label: 'Coaster', value: 'Coaster' },
    { label: 'Handysize', value: 'Handysize' },
    { label: 'Handymax', value: 'Handymax' },
    { label: 'Supramax', value: 'Supramax' },
    { label: 'Ultramax', value: 'Ultramax' },
    { label: 'Panamax', value: 'Panamax' },
    { label: 'Kamsarmax', value: 'Kamsarmax' },
    { label: 'Ultra Panamax', value: 'Ultrapanamax' },
    { label: 'Capesize', value: 'Capesize' },
    { label: 'Very Large Ore Carrier', value: 'VLOC' },
    { label: 'Chinamax', value: 'Chinamax' },
    { label: 'Coastal', value: 'Coastal' },
    { label: 'Intermediate', value: 'Intermediate' },
    { label: 'Handytankers', value: 'Handytankers' },
    { label: 'MR', value: 'MR' },
    { label: 'LR1 / Panamax', value: 'LR1/Panamax' },
    { label: 'LR2 / Aframax', value: 'LR2/Aframax' },
    { label: 'LR3 / Suezmax', value: 'LR3/Suezmax' },
    { label: 'VLCC', value: 'VLCC' },
    { label: 'Coasters', value: 'Coasters' },
    { label: 'MGC', value: 'MGC' },
    { label: 'LGC', value: 'LGC' },
    { label: 'VLGC', value: 'VLGC' },
    { label: 'VLEC', value: 'VLEC' },
  ];
}

export function getVoyageFormSegmentLabels(): string[] {
  return getVoyageFormSegmentOptions().map((opt) => opt.label);
}
export function getvesselOptions() {
  return ['Aframax', 'Handy', 'LPG', 'LR1', 'LR2', 'MR', 'Suezmax'];
}
export function getRequestersOptions() {
  return [
    'ALS',
    'HAJ',
    'HAS',
    'KER',
    'INV',
    'MAL',
    'PHJ',
    'PRA',
    'RAS',
    'SAG',
    'SOS',
    'BHY',
    'NAB',
  ];
}
export function getConditionOptions() {
  return ['Laden', 'Ballast'];
}
export function getMonthlyConditionOptions() {
  return ['Laden', 'Ballast', 'Both'];
}
export function getmonths() {
  return [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
}
export function getOperatorList() {
  return [
    'Satish - SAKA',
    'Sandokan - SABA',
    'Roman - ROAK',
    'Ahmet - AAHA',
    'Nikita - NIAL',
    'Jeet - JESH',
    'Rahul - RAPA',
    'Abhishek - AHKM',
  ];
}


export function standardizeSegment(segment: any): string {
  if (!segment) return '';

  const value = String(segment)
    .trim()
    .replace(/\s*\/\s*/g, '/')
    .replace(/\s+/g, ' ');

  const segmentMap: Record<string, string> = {
    'coaster': 'Coaster',
    'coasters': 'Coasters',
    'handysize': 'Handysize',
    'handymax': 'Handymax',
    'handytankers': 'Handytankers',
    'supramax': 'Supramax',
    'ultramax': 'Ultramax',
    'panamax': 'Panamax',
    'kamsarmax': 'Kamsarmax',
    'ultrapanamax': 'Ultrapanamax',
    'capesize': 'Capesize',
    'vloc': 'VLOC',
    'chinamax': 'Chinamax',

    'coastal': 'Coastal',
    'intermediate': 'Intermediate',
    'mr': 'MR2',
    'mr2': 'MR2',
    'lr1': 'LR1/Panamax',
    'lr1/panamax': 'LR1/Panamax',
    'lr2': 'LR2/Aframax',
    'lr2/aframax': 'LR2/Aframax',
    'lr3': 'LR3/Suezmax',
    'lr3/suezmax': 'LR3/Suezmax',
    'vlcc': 'VLCC',

    'mgc': 'MGC',
    'lgc': 'LGC',
    'vlgc': 'VLGC',
    'vlec': 'VLEC',
  };

  return segmentMap[value.toLowerCase()] || value;
}